<div id="enrolltoday">
     <div class="d-flex justify-content-between align-items-center" id="page-title">
          <h1 [innerHtml]="'Enroll Today' | translator:'base'">
               Enroll Today
          </h1>
     </div>
     <div class="row">
          <div class="col-lg-8">
               <p [innerHtml]="'Welcome_Once we have' | translator:'base'">
                    Once your enrollment agreement has been processed, you will receive a Welcome email containing
                    information about PSP and instructions for creating a PSP Login.gov account.
               </p>
               <p [innerHtml]="'Welcome_An Accout' | translator:'base'">
                    An account holder may choose to withdraw from
                    the PSP program at any time. If no PSP records
                    have been requested, the subscription fee will
                    be refunded in full.
               </p>
               <p>
                    <a routerLink="/signup/1" class="btn btn-primary btn-strong" (click)="scrollToTop()"
                         [innerHtml]="'Welcome_Enroll Online' | translator:'base'"
                         [title]="'Welcome_Enroll Online' | translator:'base'" name="companyNext1" id="companyNext1"
                         [autofocus]="true">Enroll Online
                    </a>
               </p>
               <hr>
               <p [innerHtml]="'Welcome_If you' | translator:'base'">
                    If you would prefer to fill out paperwork and
                    mail it in, please use one of the following
                    forms:
               </p>
               <ul>
                    <li>
                         <button (click)="openDocument('PSPMotorCarrierEnrollment')" class="btn btn-link underline"
                              [innerHtml]="'Welcome_Download PSP MCE' | translator:'base'"
                              [title]="'Welcome_Download PSP MCE' | translator:'base'"
                              name="Download-Motor-Carrier-Agreement" id="Download-Motor-Carrier-Agreement">Download the
                              PSP Motor CarrierEnrollment Agreement (PDF)</button>
                    </li>
                    <li>
                         <button (click)="openDocument('ISPAccountHolderAgreement')" class="btn btn-link underline"
                              [innerHtml]="'Welcome_Download PSP ISP' | translator:'base'"
                              [title]="'Welcome_Download PSP ISP' | translator:'base'" name="Download-ISP-Agreement"
                              id="Download-ISP-Agreement">Download the PSP Industry Service Provider Enrollment
                              Agreement (PDF)
                         </button>
                    </li>
               </ul>
               <p>
                    <a href="http://get.adobe.com/reader/"
                         class="btn btn-outline-primary btn-sm align-items-center btn-brand" target="_blank"
                         title="Adobe PDF" rel="noopener noreferrer" role="button"
                         [innerHtml]="'DownloadPDFButtonText' | translator:'base'">Download a free PDF viewer (new
                         window)</a>
               </p>
          </div>
          <div class="col-lg-4 sidebar">
               <div class="card shadow-sm rounded-0 border-0">
                    <div class="card-body">
                         <h2 class="card-title h5" [innerHtml]="'HaveQuestions' | translator:'base'">
                              Have Questions?
                         </h2>
                         <p [innerHtml]="'Welcome_Download PSP customer' | translator:'base'">
                              The PSP customer service team is available
                              Monday through Thursday from 8 AM to 6 PM ET,
                              and on Friday from 8 AM to 5 PM ET. To chat with
                              an online representative, click the "LIVE HELP"
                              button in the top-right corner of this page. You
                              can also email us at
                              <a href="mailto:PSPenrollment@tylertech.com" title="PSPenrollment@tylertech.com"
                                   name="PSPenrollment@tylertech.com">PSPenrollment&#64;tylertech.com</a>
                              or call toll-free at
                              <a name="877-642-9499" href="tel:8776429499"
                                   title="Phone number 8776429499">877-642-9499</a>.
                         </p>
                         <p [innerHtml]="'Welcome_Download PSP Industry' | translator:'base'">
                              Industry service providers can learn more about
                              PSP participation by downloading the Industry
                              Service Provider PSP agreement or contacting
                              <a href="mailto:PSPenrollment@tylertech.com" title="PSPenrollment@tylertech.com"
                                   name="PSPenrollment@tylertech.com">PSPenrollment&#64;tylertech.com</a>.
                         </p>
                    </div>
               </div>
          </div>
     </div>

</div>